import { TMessageType } from "../InfoMessageComponent/InfoMessageComponent";
import { MAX_UPLOAD_FILE_SIZE } from "./constants";

export const getMessageTypeFromFromFile = (
  selectedFile: File,
  isRedirecting: boolean
): TMessageType => {
  if (isRedirecting) {
    return "redirecting";
  }
  if (
    selectedFile.name.split(".")[selectedFile.name.split(".").length - 1] !==
    "xlsx"
  ) {
    return "file-type-error";
  }

  if (selectedFile.size > MAX_UPLOAD_FILE_SIZE) {
    return "file-size-error";
  }

  return "info";
};
